import React from 'react'
import { render } from 'react-dom'
import { Router, Route, IndexRoute, browserHistory, applyRouterMiddleware } from 'react-router'
import { useScroll } from 'react-router-scroll';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux'
import Pages from './pages';
import getBrandConfig from '../config/brand';
import configureStore from './redux/store/configureStore'
import { BEFORE_ROUTE_CHANGE } from './redux/constants'
import './global.scss';

/**
 * Entry point for the Payment Estimator App
 * Redux Router setup allows for use of back/forward buttons in browser
 * as well as deep linking to specific models/trims
 */

const brandConfig = getBrandConfig(process.env.BRAND_CHANNEL, process.env.LANG, process.env.SLOT, process.env.VENDOR); // eslint-disable-line
const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);
const middleware = applyRouterMiddleware(useScroll());
const rootPath = brandConfig.landingPage || '/';
const notifyRouteChange = (routeName) => {
  store.dispatch({
    type: BEFORE_ROUTE_CHANGE,
    routeName,
  })
};

/* eslint-disable */
const routes = (
  <Route onEnter={() => { notifyRouteChange('modelLineSelect') }} path={rootPath} component={Pages.App}>
    <IndexRoute component={Pages.ModelLineSelect} />
    <Route onEnter={() => { notifyRouteChange('trimSelect') }} path=":model" component={Pages.ModelView}>
      <Route onEnter={() => { notifyRouteChange('estimatePayments') }} path=":trim" component={Pages.TrimView} />
      <Route onEnter={() => { notifyRouteChange('noIncentives') }} path=":trim/no-incentives" component={Pages.NoIncentiveView} />
    </Route>
  </Route>
);
/* eslint-enable */

render(
  <Provider store={store}>
    <Router history={history} routes={routes} render={middleware} />
  </Provider>,
  document.getElementById('nna-payment-estimator')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/